var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcWalking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5C11 3.89543 11.8955 3 13 3C14.1046 3 15 3.89543 15 5C15 6.10457 14.1046 7 13 7C11.8955 7 11 6.10457 11 5ZM11.4453 8.16795C11.8419 7.90353 12.3701 7.95583 12.7071 8.29289L15.5924 11.1781L17.4472 12.1056C17.9412 12.3526 18.1414 12.9532 17.8945 13.4472C17.6475 13.9412 17.0468 14.1414 16.5528 13.8944L14.5528 12.8944C14.4567 12.8464 14.3689 12.7831 14.2929 12.7071L12.6142 11.0283L12.0856 13.6713L14.7071 16.2929C14.8169 16.4027 14.8996 16.5365 14.9487 16.6838L15.9487 19.6838C16.1234 20.2077 15.8402 20.774 15.3163 20.9487C14.7923 21.1233 14.226 20.8402 14.0513 20.3162L13.126 17.5402L11.274 15.6882L8.89445 20.4472C8.64747 20.9412 8.04679 21.1414 7.55281 20.8944C7.05884 20.6474 6.85861 20.0468 7.1056 19.5528L10.0457 13.6726L10.546 11.1712L9.84021 11.6417L8.94871 14.3162C8.77406 14.8402 8.20774 15.1233 7.6838 14.9487C7.15986 14.774 6.8767 14.2077 7.05134 13.6838L8.05134 10.6838C8.12167 10.4728 8.2603 10.2913 8.44533 10.1679L11.4453 8.16795Z",
    fill: "#1C1F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWalking);
export default __webpack_public_path__ + "static/media/Ic_walking.5e12aa1396ca670320594a8213f1a963.svg";
export { ForwardRef as ReactComponent };